import * as React from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import * as Style from "./style"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Grid,
  Pagination,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material"
import { Button } from "react-bootstrap"
import { FiDownload } from "react-icons/fi"
import { useEffect, useState } from "react"
import { CiSearch } from "react-icons/ci"
import { useGetBookingHistoryQuery } from "../../features/OverViewAuth/overViewApi"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import dummyImage from "../../images/dummy-icon.png"
import RatingStars from "../common/rating"
import Dropdown from "react-bootstrap/Dropdown"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import noDataHistory from "../../images/no-history.png"
import CenteredSpinner from "../common/CenteredSpinner"
import { CiFilter } from "react-icons/ci" // combine imports
import { MdKeyboardArrowDown } from "react-icons/md" // dropdown arrow
import { TbArrowsSort } from "react-icons/tb"
import useDebounceCallback from "../../utils/useDebounceCallback"

const statusButton = ["All", "Completed", "Expired", "Declined"]

export default function BasicTabs() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchQuery, setSearchQuery] = useState<string>("")
  const [listCount, setListCount] = useState<string>("10")
  const [statusChangePayment, setStatusChangePayment] = useState<string>("")
  const [statusIndex, setStatusIndex] = useState<number>()
  const [shortdate, setShortDate] = useState<number>(-1)
  const navigate = useNavigate()
  const [selectedPage, setSelectedPage] = useState(1)
  const searchTypeStatus = searchParams.get("type")

  const updateSearchParam = (input: string) => {
    const updated = new URLSearchParams(searchParams);
    if (input.trim()) {
      updated.set("search_name", input.trim());
    } else {
      updated.delete("search_name");
    }
    updated.set("pageNo", "1");
    setSearchParams(updated)
  };
  const update = useDebounceCallback(updateSearchParam, 200)
  const {
    data: bookingHistory,
    isFetching,
    isLoading,
  } = useGetBookingHistoryQuery(
    {
      postStatus: searchParams.get("type"),
      pageNo: selectedPage,
      from: shortdate,
      searchName: searchParams.get("search_name")?.trim() ?? "",
      pageLimit: listCount,
      paymentStatus: statusChangePayment,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  const handlePageChange = (event: any, value: any) => {
    setSelectedPage(value)

    const updated = new URLSearchParams(searchParams);
    updated.set("pageNo", value.toString());
    setSearchParams(updated)
  }

  const searchBarHandle = (e: any) => {
    const input = e.target.value;
    setSearchQuery(input)
    update(input)
  }

  const enterSearch = (event: any) => {
    if (event.key == "Enter") {
      SearchQuerryhandle()
    }
  }
  const SearchQuerryhandle = () => {
  }

  const handleListCount = (e: any) => {
    setListCount(e.target.value)
  }

  const handleButton = (name: any, index: number) => {
    setListCount("10")
    setStatusIndex(index)
    const updated = new URLSearchParams(searchParams);
    updated.set("type", name);
    updated.delete("pageNo");
    if (name !== "Completed") {
      setStatusChangePayment("")
    }
    setSearchParams(updated)
  }

  React.useEffect(() => {
    if (!searchParams.get("type")) setSearchParams({ type: "All" })
  }, [])

  const shortingDatelist = () => {
    setShortDate(shortdate == 1 ? -1 : 1)
  }

  const handleDownload = (
    event: React.MouseEvent<HTMLElement>,
    imageUrl: any,
  ) => {
    event.stopPropagation()
    const url = imageUrl
    const newTab = window.open(url, "_blank")
    if (newTab) {
      newTab.focus()
    } else {
      window.location.href = url
    }
  }

  const handleSelectPayment = (eventKey: any) => {
    setStatusChangePayment(eventKey)
  }

  useEffect(() => {
    const page = searchParams.get("pageNo");

    if (!page) {
      const updated = new URLSearchParams(searchParams);
      updated.set("pageNo", "1");
      setSearchParams(updated);
    }
  }, []);
  return (
    <>
      <Style.Overview>
        <Box sx={{ width: "100%" }}>
          <Box
            className="d-flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: "10px",
              width: "100%",
              flexWrap: "wrap", // optional: wrap for sm and up
            }}>
              {/* Search Field and Button */}
              <Box sx={{
                display: 'flex',
                width: {
                  xs: '100%',
                  sm: '50%',
                },
                pr: {
                  xs: 4,
                  sm: 0,
                },
              }}>
                <TextField
                  id="outlined-basic"
                  className="search-field"
                  label="Service Provider"
                  variant="outlined"
                  value={searchQuery}
                  onChange={searchBarHandle}
                />
                <Button
                  variant="contained"
                  className="search-btn"
                  onClick={SearchQuerryhandle}
                  onKeyDown={enterSearch}
                >
                  <CiSearch />
                </Button>
                {/* <Dropdown
                  onSelect={handleSelectPayment}
                  aria-placeholder="Payment"
                  style={{ marginLeft: "20px" }}
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    style={{
                      marginLeft: "10px",
                      border: "1px solid #878787",
                      backgroundColor: "#fff",
                      padding: "15px 30px",
                      color: "#000",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    disabled={
                      searchTypeStatus == "Expired" ||
                      searchTypeStatus == "Declined"
                    }
                  >
                    {statusChangePayment == "Unpaid"
                      ? "Pending"
                      : statusChangePayment
                      ? statusChangePayment
                      : "Payment"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="payment-dropdown"
                    style={{
                      marginTop: "10px",
                      width: "200px",
                      border: "unset",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "14px 8px",
                      boxShadow: "2px 2px 2px 1px rgb(0 0 0 / 20%)",
                    }}
                  >
                    <Dropdown.Item eventKey={"Paid"}>Paid</Dropdown.Item>
                    <Dropdown.Item eventKey={"Unpaid"}>Pending</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}


              </Box>
              <Box sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "row"
                },
                gap: {
                  xs: "10px",
                  sm: "0px"
                }
              }}>
                {/* <Dropdown
                  onSelect={handleSelectPayment}
                  aria-placeholder="Payment"
                  className=" ms-0 ms-lg-4"
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="payment-toggle"
                    style={{
                      marginLeft: "10px",
                      border: "1px solid #878787",
                      backgroundColor: "#fff",
                      padding: "15px 30px",
                      color: "#000",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    disabled={
                      searchTypeStatus === "Expired" || searchTypeStatus === "Declined"
                    }
                  >
                    {/* Label */}
                {/* {statusChangePayment === "Unpaid"
                  ? "Pending"
                  : statusChangePayment
                    ? statusChangePayment
                    : "Payment History"} */}
                {/* Dropdown arrow */}
                {/*}   <MdKeyboardArrowDown className="dropdown-icon" style={{ marginLeft: "8px" }} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="payment-dropdown"
                    style={{
                      marginTop: "10px",
                      width: "200px",
                      border: "unset",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "14px 8px",
                      boxShadow: "2px 2px 2px 1px rgb(0 0 0 / 20%)",
                    }}
                  >
                    <Dropdown.Item eventKey={"Paid"}>Payment Paid</Dropdown.Item>
                    <Dropdown.Item eventKey={"Unpaid"}>Payment Pending</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}


                <Box>
                  <div className="w-100">
                    <FormControl
                      sx={{ marginLeft: 1, minWidth: 200, }}
                      className="custom-field "
                    >
                      <InputLabel id="demo-simple-select-label bg-white"
                        sx={{
                          backgroundColor: "#f9f9f9",
                          px: 0.5,
                        }}
                      >View
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={handleListCount}
                        value={listCount}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={30}>30</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                      </Select>
                    </FormControl>
                  </div>{" "}
                </Box>
              </Box>


            </Box>

          </Box>
          {/* Status Buttons */}
          <Box
            sx={{
              display: "flex",
              marginTop: "10px",
              overflowX: {
                xs: "auto",
                sm: "visible"
              },
              flexWrap: {
                xs: "nowrap",
                sm: "wrap"
              }
            }}>
            {statusButton?.map((item, index) => (
              <Button
                key={index}
                variant="transparent"
                className="all-button mb-1"
                style={{
                  backgroundColor:
                    searchParams.get("type") === item
                      ? "#F475A4"
                      : ("white" as any),
                  color:
                    searchParams.get("type") === item
                      ? "white"
                      : ("black" as any),
                  marginRight: "10px",
                  padding: "6px 30px",
                  boxShadow: "0px 4px 25px 0px rgba(0, 0, 0, 0.07)",
                }}
                onClick={() => handleButton(item, index)}
              >
                {item}
              </Button>
            ))}
          </Box>

          <Box
            className="d-flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography align="left" variant="h2" mt={2} mb={2}>
              Booking History{" "}
            </Typography>
          </Box>

          <TableContainer
            component={Paper}
            className="dashboard-table-wrapper custom-scrollbar overflow-y-hidden"
          >
            <Table
              style={{
                minWidth: 650,
                border: "none",
                backgroundColor: "#fff",
                borderRadius: "16px",
                overflow: "hidden",
              }}
              className="dashboard-table"
              aria-label="simple table"
            >
              {bookingHistory?.data?.length > 0 && (
                <TableHead>
                  <TableRow>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center" className="service-head">
                      Service Provider
                    </TableCell>
                    <TableCell align="center">Phone Number</TableCell>
                    <TableCell align="center">Service</TableCell>
                    <TableCell align="center">Language</TableCell>
                    <TableCell align="center" onClick={shortingDatelist}>
                      Date & Time <TbArrowsSort />
                    </TableCell>
                    {/* <TableCell align="center">End Time</TableCell> */}
                    <TableCell align="center">Status</TableCell>
                    {searchTypeStatus !== "Declined" &&
                      searchTypeStatus !== "Expired" && (
                        <TableCell align="center">Payment</TableCell>
                      )}
                  </TableRow>
                </TableHead>
              )}

              {isLoading || isFetching ? (
                <>
                  {" "}
                  <CenteredSpinner />
                </>
              ) : (
                <TableBody>
                  {bookingHistory?.data?.length > 0 ? (
                    bookingHistory?.data?.map((row: any, index: number) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(`/dashboard/bookings/details/${row._id}`)
                        }
                      >
                        <TableCell className="user-img">
                          {row?.assignedTo?.length > 0 ? (
                            row?.assignedTo?.slice(0, 1)?.map((assign: any) => (
                              <div className="img-wrapper ms-1">
                                <img
                                  src={assign?.profilePic || dummyImage}
                                  style={{
                                    width: "74px",
                                    height: "74px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ))
                          ) : (
                            <img src={dummyImage} style={{ width: "74px" }} />
                          )}
                        </TableCell>
                        <TableCell component="td" align="center" scope="row">
                          {row?.assignedTo?.length > 0 ? (
                            row?.assignedTo?.slice(0, 1)?.map((assign: any) => (
                              <span className="text flex-column gap-2">
                                {assign?.name || "--"}
                                <span className="minh-1">
                                  {row?.assignedTo?.length > 1 && (
                                    <span
                                      className="minh-1"
                                      style={{ color: "grey" }}
                                    >
                                      + {row?.assignedTo?.slice(1)?.length}{" "}
                                      Others
                                    </span>
                                  )}
                                </span>
                                <span className="minh-1">
                                  <RatingStars
                                    rating={assign?.rating?.$numberDecimal}
                                  />
                                </span>
                              </span>
                            ))
                          ) : (
                            <span className="text-danger">
                              No Provider Assigned
                            </span>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {row?.assignedTo?.length > 0 ? (
                            row?.assignedTo?.slice(0, 1)?.map((assign: any) => (
                              <span className="email">
                                <span>{assign.contactNo || "-----"}</span>
                              </span>
                            ))
                          ) : (
                            <span>{"-----"}</span>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title={row?.service?.name || ""} arrow>
                            <span>
                              {(row?.service?.name || "").length > 13
                                ? row?.service?.name.slice(0, 13) + "..."
                                : row?.service?.name}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          <span
                            style={{
                              display: "inline-flex",
                              gap: "8px",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              padding: "4px",
                            }}
                          >
                            {row?.language && row.language.length > 0 ? (
                              row.language.map((lang: string, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #fff",
                                    backgroundColor: "#f475A4",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "2px 8px",
                                    minHeight: "40px",
                                    color: "#fff",
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                  }}
                                >
                                  {lang}
                                </div>
                              ))
                            ) : (
                              <span style={{ color: "#999" }}>-----</span>
                            )}
                          </span>
                        </TableCell>

                        <TableCell align="center">
                          <span className="datetime">
                            <span className="d-flex flex-column">
                              <span className="weekday">
                                <FormatDate dateString={row?.from} />
                              </span>

                              <span>
                                <FormatTime dateString={row?.from} />
                              </span>

                              <span>
                                <FormatChangeTime dateString={row?.from} />
                              </span>
                            </span>
                          </span>
                        </TableCell>

                        <TableCell align="center">
                          <span
                            className={row.requeststatus}
                            style={{
                              color:
                                row.status == "Completed"
                                  ? "green"
                                  : row.status == "Cancelled"
                                    ? "red"
                                    : row.status == "Expired"
                                      ? "#FF9900"
                                      : "",
                              fontWeight: "bold",
                            }}
                          >
                            {row.status}
                          </span>
                        </TableCell>
                        {searchTypeStatus !== "Declined" &&
                          searchTypeStatus !== "Expired" && (
                            <TableCell align="center">
                              <span
                                className={row.payment}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  className={`${row?.ispaymentVeified == true
                                    ? "payment-btn"
                                    : row.ispaymentVeified == false &&
                                      row.status == "Completed"
                                      ? "payment-unpaid"
                                      : row.status == "Expired" ||
                                        row.status == "Declined"
                                        ? "payment-other"
                                        : "payment-other"
                                    } `}
                                >
                                  {row?.ispaymentVeified == true
                                    ? "Paid"
                                    : row.ispaymentVeified == false &&
                                      row.status == "Completed"
                                      ? "Pending"
                                      : row.status == "Expired" ||
                                        row.status == "Declined"
                                        ? "......"
                                        : "......"}
                                </Button>
                                {row?.receipt_url && (
                                  <FiDownload
                                    style={{
                                      marginLeft: "5px",
                                      fontSize: "20px",
                                    }}
                                    onClick={(e: any) =>
                                      handleDownload(e, row?.receipt_url)
                                    }
                                  />
                                )}
                              </span>
                            </TableCell>
                          )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={7}
                        sx={{
                          width: "100%",
                          pointerEvents: "none",
                          border: "none",
                          height: "498px",
                        }}
                      >
                        <img
                          src={noDataHistory}
                          style={{
                            width: "100%",
                            maxWidth: "208px",
                          }}
                        />
                        <span className="no-data-text">No Booking History</span>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Box>
        {bookingHistory?.data?.length > 0 && (
          <Box className="d-md-flex justify-content-between align-items-center mt-3">
            <Typography variant="body1" className="white-space">
              {" "}
              Showing {bookingHistory?.totalDocument?.showingData} /{" "}
              {bookingHistory?.totalDocument?.totalCount} Total
            </Typography>
            <Grid container justifyContent="flex-end">
              <Grid item md={3}>
                <Box display="flex" className="flex-column">
                  <Stack spacing={2} className="mb-3">
                    <Pagination
                      count={bookingHistory?.totalDocument?.totalPages}
                      color="secondary"
                      className="custom-pagination"
                      page={selectedPage}
                      onChange={handlePageChange}
                      sx={{
                        "& .MuiPaginationItem-page.Mui-selected": {
                          backgroundColor: "#F475A4",
                          boxSizing: "border-box",
                        },
                        "& .css-wjh20t-MuiPagination-ul": {
                          flexWrap: "nowrap",
                          justifyContent: "end",
                        },
                      }}
                    />
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Style.Overview>
    </>
  )
}
